import { render, staticRenderFns } from "./CampanasCuponesForm.vue?vue&type=template&id=1b203e31"
import script from "./CampanasCuponesForm.vue?vue&type=script&lang=js"
export * from "./CampanasCuponesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports